import React, { useContext } from 'react'

import { Input, Modal, Form, DatePicker } from 'antd'

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button';
import { MaskedInput } from 'antd-mask-input'
import SL_Select from '../../components/selects/Select';
import { Option } from 'antd/lib/mentions';
import { ERegExp } from '../../enums/ERegExp';
import moment from 'moment';
import { displayMessage } from '../../services/helper';


const inputsClassName = `border-appian-blue max-h-9 text-base`

export default function CreateDentist(props) {

    const {setShowLoading, windowHeight} = useContext(GeneralContext)


    const handleCreateDentist = (values) => {
        setShowLoading(true)

        values.specialization = mountSpecialization(values.specialization) // formatando valores pois select nao aceitou objetos como value
        values.password = "123456" // TODO

         if (values.cpf) {
            if (values.cpf.replace(/\D/g, "")?.length != 11) {
                alert(displayMessage('INVALID_CPF'), 'error')
                setShowLoading(false)
                return
            }
        }

        if (values.cell_phone_responsible) {
            if (values.cell_phone_responsible.replace(/\D/g, "")?.length != 11) {
                alert(displayMessage('INVALID_PHONE'), 'error')
                setShowLoading(false)
                return
            }
        }

        api.dentist.create(values)
            .then(
                rs => {
                    alert(displayMessage('CREATE_DENTIST_SUCCESS'), 'success', displayMessage('SUCCESS'))
                    props.refreshDentists()
                }
            ).finally(
                () => {
                    setShowLoading(false)
                    props.handleOnCloseModal()
                }
            )
    }

    const mountSpecialization = specializations => {
        return specializations.map(
            s => {
                switch (s) {
                    case 1:
                        return { code: 1, name: displayMessage('DENTIST_1') }
                    case 2:
                        return { code: 2, name: displayMessage('DENTIST_2') }
                    case 3:
                        return { code: 3, name: displayMessage('DENTIST_3') }
                }
            }
        )
    }

    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('CREATE_DENTIST')}</div>}
            visible={props.isModalVisible}
            onCancel={props.handleOnCloseModal}
            centered={true}
            footer={[]}
            width={750}
            style={{ position: 'relative' }}
            bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
        >
            <Form
                className='w-full flex flex-col gap-2 p-5'
                onFinish={handleCreateDentist}
                layout="vertical"
                requiredMark='optional'
            >
                <div className='font-bold text-lg text-appian-blue text-center'>
                    {displayMessage('DENTIST_DATA')}
                </div>

                <Form.Item
                    label={displayMessage('NAME')}
                    name="first_name"
                    className={`w-full flex`}
                    rules={[
                        { required: true, message: displayMessage('FULL_NAME_MANDATORY') },
                        { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, whitespace: true, message: displayMessage('NAME_WARNING') },
                    ]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('NAME')}
                        className={inputsClassName}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('LAST_NAME')}
                    name="last_name"
                    className={`w-full flex`}
                    rules={[
                        { required: true, message: displayMessage('FULL_NAME_MANDATORY') },
                        { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, whitespace: true, message: displayMessage('SURENAME_WARNING') },
                    ]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('LAST_NAME')}
                        className={inputsClassName}

                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('CPF')}
                    name="cpf"
                    className={`w-full flex`}
                    rules={[
                        { required: true, pattern: ERegExp.MUST_HAVE_NUMBERS.regexp, message: displayMessage('CPF_MANDATORY') },
                    ]}
                >
                    <MaskedInput
                        type="text"
                        size='large'
                        placeholder={displayMessage('CPF') + displayMessage('CPF_EXEMPLE')}
                        className={inputsClassName}
                        mask={'000.000.000-00'}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('EMAIL')}
                    name="email"
                    className={`w-full flex`}
                    rules={[{ required: true, whitespace: true, message: displayMessage('EMAIL_MANDATORY'), type: "email", }]}
                >
                    <Input
                        type="email"
                        size='large'
                        placeholder={displayMessage('EMAIL') + displayMessage('EMAIL_EXEMPLE')}
                        className={inputsClassName}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('BIRTHDAY')}
                    name="birth_day"
                    className={`w-full flex`}
                    rules={[{ required: true, message: displayMessage('BIRTHDAY_MANDATORY') }]}
                >
                    <DatePicker
                        className={inputsClassName}
                        style={{ width: '100%', height: 110 }}
                        placeholder={displayMessage('SELECT_DATE')}
                        format={'DD/MM/YYYY'}
                        disabledDate={(current) => {
                            let customDate = moment().format("YYYY-MM-DD");
                            return current && current >= moment(customDate, "YYYY-MM-DD");
                        }}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('CRO')}
                    name="cro_number"
                    className={`w-full flex`}
                    rules={[
                        { required: true, whitespace: true, message: displayMessage('CRO_MANDATORY') }
                    ]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('IDENTIFICATOR_DENTIST')}
                        className={inputsClassName}

                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('PHONE_WHATSAPP')}
                    name="cell_phone"
                    className={`w-full flex`}
                    rules={[{ required: true, pattern: ERegExp.MUST_HAVE_NUMBERS.regexp, message: displayMessage('PHONE_MANDATORY') }]}
                >
                    <MaskedInput
                        type="text"
                        size='large'
                        placeholder={displayMessage('TYPE_PHONE')}
                        className={inputsClassName}
                        mask={'(00) 00000-0000'}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('SPECIALIZATION')}
                    name="specialization"
                    rules={[{ required: true, message: displayMessage('SPECIALIZATION_MANDATORY') }]}
                >
                    <SL_Select
                        mode="multiple"
                        allowClear
                        placeholder={displayMessage('SELECT_OPTION')}
                        style={{
                            width: '100%',
                            display: null
                        }}
                    >
                        <Option index={1} value={1}>{displayMessage('DENTIST_1')}</Option>
                        <Option index={2} value={2}>{displayMessage('DENTIST_2')}</Option>
                        <Option index={3} value={3}>{displayMessage('DENTIST_3')}</Option>
                    </SL_Select>
                </Form.Item>


                <SL_Button
                    type="primary"
                    size='large'
                    htmlType="submit"
                    className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                >
                    {displayMessage('CREATE_DENTIST')}
                </SL_Button>
            </Form>
        </Modal >
    )
}